// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8abf7e44","88":"87247128","575":"5693bedd","605":"f81ecdd2","623":"4f5f1ce9","788":"bee4151f","897":"a507f47c"}[chunkId] + ".chunk.js";
};